export const JOURNEY_SIGNAL_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/

export const UNMAPPED_SIGNALS = {
  SIGNAL: 'unmapped-signal',
  TERMINAL_ERROR: 'unmapped-terminal-error',
} as const

export const toKebabCase = (value: string): string =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()
    .replace(/-+/g, '-')

export const sanitizeSignal = (value: string): string => (JOURNEY_SIGNAL_PATTERN.test(value) ? value : UNMAPPED_SIGNALS.SIGNAL)

export const JOURNEY_TAG_KEYS = [
  'merchantId',
  'country',
  'windowType',
  'idvType',
  'paymentType',
  'cohort',
  'crossRegion',
  'cashAuthJourneyId',
  'cashAuthMethod',
  'cashAuthResult',
] as const

export const TAG_VALUE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_.:-]*$/

export const isAllowedTag = (tag: string): boolean => {
  const separator = tag.indexOf(':')
  if (separator <= 0) {
    return false
  }
  return (JOURNEY_TAG_KEYS as readonly string[]).includes(tag.slice(0, separator)) && TAG_VALUE_PATTERN.test(tag.slice(separator + 1))
}
